import React, { useState, useEffect } from "react";
import { Box, Stack, ToggleButton, ToggleButtonGroup, IconButton, Button, Typography,} from "@mui/material";
import DoubleArrowIcon from "@mui/icons-material/DoubleArrow";
import { useNavigate } from "react-router-dom";
import ModalLogin from "../../../../components/Modal/Login/Login";
import { steps } from "../../../../constants/Devolve/steps";
import { StepWrapper } from "./Styled";
import StepCard from "./StepCard";

export default function CashBackGuide() {
    const [activeStep, setActiveStep] = useState(0);
    const [slideDirection, setSlideDirection] = useState("right");
    const [openModal, setOpenModal] = useState(false);
    const navigate = useNavigate();

    const lastStepIndex = steps.length - 1;
    const currentStep = steps[activeStep];

    // Scroll automático para FAQ
    useEffect(() => {
        if (activeStep === lastStepIndex) {
        const faq = document.querySelector("#faq");
        if (faq) setTimeout(() => faq.scrollIntoView({ behavior: "smooth" }), 500);
        }
    }, [activeStep, lastStepIndex]);

    const handleStepChange = (_, value) => {
        if (value !== null) {
        setSlideDirection(value > activeStep ? "right" : "left");
        setActiveStep(value);
        }
    };

    const handleNavigation = (link) => {
        if (!link) return;
        if (link.startsWith("#")) {
        document.querySelector(link)?.scrollIntoView({ behavior: "smooth" });
        } else if (link.startsWith("/")) {
        navigate(link);
        } else {
        window.open(link, "_blank");
        }
    };

    return (
        <Box sx={{ px: 2, py: 6 }}>
        <Typography
            variant="h5"
            sx={{
            fontWeight: "bold",
            color: "#1B1464",
            fontSize: { xs: "1.2rem", md: "1.8rem" },
            mb: { xs: 3, md: 5 },
            textAlign: "center",
            }}
        >
            COMO GANHAR CASHBACK EM MINHAS COMPRAS?
        </Typography>

        {/* Navegação */}
        <Stack direction="row" justifyContent="center" flexWrap="wrap" gap={1} mb={4}>
            <ToggleButtonGroup
            exclusive
            value={activeStep}
            onChange={handleStepChange}
            sx={{
                flexWrap: "wrap",
                justifyContent: "center",
                "& .MuiToggleButton-root": {
                borderRadius: 18,
                px: 2.8,
                border: "none",
                textAlign: "center",
                maxWidth: 130,
                },
            }}
            >
            {steps.map((step, index) => (
                <ToggleButton
                key={index}
                value={index}
                sx={{
                    textTransform: "none",
                    color: "#1B1464",
                    fontWeight: "bold",
                    fontSize: 13,
                    backgroundColor: activeStep === index ? "#4285f4" : "#F4CC3B",
                    "&:hover": { backgroundColor: "#f4c829" },
                    "&.Mui-selected": {
                    backgroundColor: "#3772CB !important",
                    color: "#fff",
                    },
                    m: 0.5,
                }}
                >
                {step.title}
                </ToggleButton>
            ))}
            </ToggleButtonGroup>

            <Button
            onClick={() =>
                document.querySelector("#faq")?.scrollIntoView({ behavior: "smooth" })
            }
            sx={{
                borderRadius: 18,
                px: 2.8,
                textTransform: "none",
                color: "#1B1464",
                fontWeight: "bold",
                fontSize: 13,
                backgroundColor: "#F4CC3B",
                "&:hover": { backgroundColor: "#f4c829" },
                m: 0.5,
                maxWidth: 130,
            }}
            >
            Ainda com Dúvidas?
            </Button>
        </Stack>

        <ModalLogin open={openModal} handleClose={() => setOpenModal(false)} />

        {/* Cards */}
        <Stack direction="row" alignItems="center" justifyContent="center" spacing={2}>
            <IconButton
            onClick={() => setActiveStep((prev) => Math.max(0, prev - 1))}
            disabled={activeStep === 0}
            sx={{ color: "#f4c829" }}
            >
            <DoubleArrowIcon sx={{ transform: "rotate(180deg)", fontSize: { xs: 32, md: 72 } }} />
            </IconButton>

            <StepWrapper key={activeStep} direction={slideDirection}>
            <StepCard
                step={currentStep}
                index={activeStep}
                openModal={() => setOpenModal(true)}
                navigateTo={handleNavigation}
            />
            </StepWrapper>

            <IconButton
            onClick={() => setActiveStep((prev) => Math.min(lastStepIndex, prev + 1))}
            disabled={activeStep === lastStepIndex}
            sx={{ color: "#f4c829" }}
            >
            <DoubleArrowIcon sx={{ fontSize: { xs: 32, md: 72 } }} />
            </IconButton>
        </Stack>

        {/* Dots (mobile) */}
        <Stack
            direction="row"
            justifyContent="center"
            spacing={1}
            mt={3}
            sx={{ display: { xs: "flex", md: "none" } }}
        >
            {steps.map((_, i) => (
            <Box
                key={i}
                onClick={() => setActiveStep(i)}
                sx={{
                width: activeStep === i ? 14 : 10,
                height: activeStep === i ? 14 : 10,
                borderRadius: "50%",
                cursor: "pointer",
                backgroundColor: activeStep === i ? "#4285f4" : "#ccc",
                transition: "all 0.3s ease",
                }}
            />
            ))}
        </Stack>
        </Box>
    );
}